import { ApplicationState } from '..';
import { AiScriberState, AiScriberStatus, AiScriberReportDraft } from './state';

const getAiScriber = (state: ApplicationState): AiScriberState => state.aiScriber;

export const getAiScriberStatus = (state: ApplicationState): AiScriberStatus =>
    getAiScriber(state).status;

export const getAiScriberSessionId = (state: ApplicationState): string | undefined =>
    getAiScriber(state).sessionId;

export const getAiScriberAppointmentId = (state: ApplicationState): string | undefined =>
    getAiScriber(state).appointmentId;

export const getAiScriberSelectedTemplateId = (state: ApplicationState): string | undefined =>
    getAiScriber(state).selectedTemplateId;

export const getAiScriberElapsedSeconds = (state: ApplicationState): number =>
    getAiScriber(state).elapsedSeconds;

export const getAiScriberTranscript = (state: ApplicationState): string =>
    getAiScriber(state).transcript;

export const getAiScriberErrorKey = (state: ApplicationState): string | undefined =>
    getAiScriber(state).errorKey;

export const getAiScriberReportDraft = (state: ApplicationState): AiScriberReportDraft | undefined =>
    getAiScriber(state).reportDraft;
